export enum FileExtensionsEnum {
    Pdf = 'pdf',
    Png = 'png',
    Jpg = 'jpg',
    Jpeg = 'jpeg'
}
